import React, { useEffect, useState } from "react";
import { Table, Container, Row } from 'reactstrap';
import { useDispatch } from "react-redux";
import { getUserLoginHistory } from "../actions/User.js";
import Spinner from './Spinner/Spinner.js';
import Pagination from 'rc-pagination';
import SetLimitEntries from '../components/SetLimitEntries';
import { ENG_LOCALE } from '../lib/constants';
import utils from "../lib/utils.js";

const initialState = {
  limit: 25,
  page: 1,
  totalDocs: null,
}

const LoginHistory = () => {
  const dispatch = useDispatch();
  const url = new URLSearchParams(window.location.search);
  const userID = url.get('userID');

  const token = localStorage.getItem('jwtToken') || null;

  const [data, setData] = useState(null);
  const [paginationOptions, setPaginationOptions] = useState(initialState);
  const [limit, setLimit] = useState(25);

  const getData = async (value = {}) => {
    setData(false);

    const data = await dispatch(
      getUserLoginHistory(token, userID, { ...paginationOptions, ...value }),
    );

    if (data.failure) {
      setData(data);
      return;
    }

    const { docs, page, limit, totalDocs } = data;
    setData(docs)

    setPaginationOptions((paginationOptions) => ({ ...paginationOptions, page, limit, totalDocs }))
  };

  const handlePagination = async (currPage, _) => {
    await getData({ page: currPage })
  }

  const handleLimit = async (value) => {
    setLimit(value);
    await getData({ limit: value });
  }

  useEffect(() => { getData() }, [])

  if (!data) {
    return (
      <Spinner />
    )
  }

  if (data.failure) {
    return (<h1 style={{ paddingTop: '20vh', fontSize: '1.5rem' }}>Cannot fetch data please try again</h1>)
  }

  return (
    <>
      {data && data.length && (<Container style={{ paddingTop: '80px' }}>
        <Table style={{ maxHeight: "80vh" }}>
          <thead>
            <tr>
              <th>IP Address</th>
              <th>Platform</th>
              <th>Login Success</th>
              <th>Failure Reason</th>
              <th>Date</th>
              <th>Time</th>
            </tr>
          </thead>
          <tbody>
            {data.map((data, idx) => {
              return (<tr key={idx}>
                <td>{data.ipAddress || 'N/A'}</td>
                <td>{data.platform}</td>
                <td>{data.loginSuccess ? 'Yes' : 'No'}</td>
                <td>{data.failureReason || 'None'}</td>
                <td>{utils.getDateTimeFormat(data.createdAt, 'regular')}</td>
                <td>{utils.getDateTimeFormat(data.createdAt, 'time')}</td>
              </tr>)
            })}
          </tbody>
        </Table>
        <Row className="justify-content-md-center">
          <SetLimitEntries selectOptions={[25, 50, 100]} value={limit} onChange={handleLimit} />
          <Pagination
            locale={ENG_LOCALE}
            className="pagination-container"
            onChange={handlePagination}
            current={paginationOptions.page}
            total={paginationOptions.totalDocs}
            pageSize={parseInt(paginationOptions.limit, 10)}
            showLessItems
            showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
          />
        </Row>
      </Container>) || <h1 style={{ paddingTop: '20vh', fontSize: '1.5rem' }}>No Login History Data</h1>}
    </>
  )
}

export default LoginHistory;
